export default "__VITE_ASSET__BOz22JpC__"